/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "240")




export interface API22549Req {
  
  /** (String) */
  recordId?: string;
    
};



export interface API22549Res {
  /**   */
  code?: string;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  /**   */
  exceptionMsg?: string;
  
};


// 22549 停止任务

export interface IUseGetAPI22549Return {
  /** 停止任务: 接口请求状态 */
  isAPI22549Loading: boolean;
  /** 停止任务: 接口请求返回数据 */
  dataAPI22549: API22549Res;
  /**  停止任务: 接口数据请求方法 */
  fetchAPI22549Data:  (inputs: API22549Req, config?: YWRequestConfig) => Promise<API22549Res>;
  /** 停止任务: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI22549 = ():IUseGetAPI22549Return => {
  let isMount = true;
  const [isAPI22549Loading, setIsAPI22549Loading] = useState(false);
  const [dataAPI22549, setDataAPI22549] = useState<API22549Res>({} as API22549Res);
  const requestUrl = `${basePath}/ywwl-upload-export/export/task/stop`;

  const fetchAPI22549Data = async (inputs: API22549Req, config?: YWRequestConfig): Promise<API22549Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API22549Req>) || {}) as API22549Req;
    
  
    if ( isMount ) {
      setIsAPI22549Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API22549Res>(`${basePath}/ywwl-upload-export/export/task/stop?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI22549(res || {} as API22549Res);
        setIsAPI22549Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI22549Loading(false);
      }
      return false as unknown as API22549Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI22549Loading,
    dataAPI22549,
    fetchAPI22549Data,
    requestUrl,
  }
}

